import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { ExamsService } from './exams.service';
import  gastroDiagnosisList  from './../assets/tables/gastroDiagnosis.json'
import { Subject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AutotextService } from './autotext.service';

export interface DropdownOptionRequest {
	clinicId: number | string;
	field: string;
}

export interface DropdownOptionAddRequest extends DropdownOptionRequest {
	value: string;
}


@Injectable({
	providedIn: 'root'
})
export class UsgService implements OnDestroy{

	gastroForm: UntypedFormGroup;
	awlForm:UntypedFormGroup
	diagnosis: any[] = [];
	diagnosisChange$ = new Subject<void>();
	diag1:any;
	sub = new Subscription();
	last;

	summaryDiagnosisAT;
	detailsFinding=[
		{name:'Terminal ileum',db:"Terminal", value: 0, comment:null},
		{name:'Caecum',db:"Caecum", value: 0, comment:null},
		{name:'Ascending colon',db:"AscendingC", value: 0, comment:null},
		{name:'Hepatic flexure',db:"HepaticF", value: 0, comment:null},
		{name:'Transverse colon',db:"TransverseC", value: 0, comment:null},
		{name:'Splenic flexure',db:"SplenicF", value: 0, comment:null},
		{name:'Descending colon',db:"DescendingC", value: 0, comment:null},
		{name:'Sigma',db:"Sigma", value: 0, comment:null},
		{name:'Recto Sigma',db:"RectoS", value: 0, comment:null},
		{name:'Rectum',db:"Rectum", value: 0, comment:null},
		{name:'Anus',db:"Anus", value: 0, comment:null}
	];
	recoverySTR=`המטופל משתחרר כשהוא מתמצא בזמן ובמקום, רפלקס בליעה ושיעול שמורים\nמצב המודינמי יציב, ללא בחילות הקאות או כאבי בטן משמעותיים.`
	dissmissionSTR=`יש לחזור הביתה בליווי, למנוחה של מספר שעות עקב קבלת הטשטוש חל איסור מוחלט על נהיגה בשמונה השעות הקרובות\nבמידה ויופיעו כאבי בטן,חום,הקאות או דימום רקטלי משמעותי ביממה שלאחר הבדיקה יש לפנות לרופא המבצע בטל: 04-6191885\nבמידה ולא ניתן ליצור קשר יש לפנות לחדר מיון עם מכתב זה`

	constructor(private http:HttpClient,private fb:UntypedFormBuilder, public es:ExamsService, private atS:AutotextService) {
		this.resetForm();
		this.resetAwl()
		this.sub = this.es.examLoaded$.subscribe(() => {
			this.resetForm();
			this.resetAwl()
			if( this.es.ExamType === 'Abdomen US' || this.es.ExamType === 'MSK Musculoskeletal' || this.es.ExamType === 'MSK & Soft Tissues' || this.es.ExamType === 'Ultrasound Scan Summary' || this.es.ExamType === 'Endoscopy' || this.es.ExamType === 'Neck scan')
				this.es.fillForm(this.gastroForm, "usGeneral", false, true,['inputControl','Dissmission']);
				this.es.fillAwlForm(this.awlForm,'AwlSchedule')
			this.buildList();
			if(es.isClosed){
				this.gastroForm.disable({emitEvent:false})
			}
		})
	 }

	/**
	 * Fetch dynamic dropdown options for a given clinic and field
	 * @param clinicId The clinic ID (GID)
	 * @param field The field name (e.g., 'ProbeType')
	 */
	getDropdownOptions(clinicId: number | string, field: string) {
		return this.http.get<string[]>(
			'/api/templates/dropdown-options',
			{ params: { clinicId: String(clinicId), field } }
		);
	}

	/**
	 * Add a new option to a dynamic dropdown for a given clinic and field
	 * @param clinicId The clinic ID (GID)
	 * @param field The field name (e.g., 'ProbeType')
	 * @param value The new value to add
	 */
	addDropdownOption(clinicId: number | string, field: string, value: string) {
		return this.http.post(
			'/api/templates/dropdown-options',
			{ clinicId, field, value }
		);
	}

	deleteDropdownOption(clinicId: number | string, field: string, value: string) {
		return this.http.delete('/api/templates/dropdown-options', {
			body: { clinicId, field, value }
		});
	}

	 resetForm(){
		 this.gastroForm = this.fb.group({
			Equipment: [''],
			ReffDoc: [''],
			Reasone : [''],
			Comments: [''],
			ExtentOfExam: [''],
			Medication: [''],
			FindingsComment:[''],
			HraDiagram:[''],
			PathologyComments:[''],
			Unit:[''],
			Dose: [''],
			imag1:[''],
			imag2:[''],
			scope1:[''],
			scope2:[''],
			Preparetion: [''],
			DignosisTree:[''],
			Diagnosis:[''],
			USDiagnosis:[''],
			Recovery:[''],
			Recomm:[''],
			Esophagus:[''],
			EsophagusComment:[''],
			Stomach:[''],
			StomachComment:[''],
			Duodenum:[''],
			DuodenumComment:[''],
			EsoJunction:[''],
			Terminal: [''],
			TerminalComment:[''],
			Caecum: [''],
			CaecumComment:[''],
			AscendingC: [''],
			AscendingCComment:[''],
			HepaticF: [''],
			HepaticFComment:[''],
			TransverseC: [''],
			TransverseCComment:[''],
			SplenicF: [''],
			SplenicFComment:[''],
			DescendingC: [''],
			DescendingCComment:[''],
			Sigma: [''],
			SigmaComment:[''],
			RectoS: [''],
			RectoSComment:[''],
			Rectum: [''],
			RectumComment:[''],
			HMO: [''],
			OtherStaff:[''],
			ASA:[''],
			BBPS:[''],
			Mellampeti:[''],
			Dissmission:[''],
			TimeOut:[''],
			Quality:[''],
			inputControl:[''],
			Anus:[''],
			AnusComment:[''],
			EsoJunctionComment:[''],
			MedicalHistory:[''],
			ReasonExamination:[''],
			Liver:[''],
			RetroPeritoneum:[''],
			Gallbladder:[''],
			AbdominalAorta:[''],
			BiliaryTract:[''],
			Kidneys:[''],
			Pancreas:[''],
			Bladder:[''],
			Intestine:[''],
			Prostate:[''],
			Summary:[''],
			ProcedureResult:[''],
			Hp:[''],
			HpComment:[''],
			Spleen:[''],
			MedicalBackground:[''],
			Pelvic:[''],
			NeckandSoftTissues:[''],
			Thyroid:[''],
			SalivaryGlands:[''],
			Parotid:[''],
			LymphNodes:[''],
			BloodVessels:[''],
			ChestWallAndBack:[''],
			AbdominalWallAndGroins:[''],
			ShoulderRight:[''],
			ShoulderLeft:[''],
			KneeRight:[''],
			KneeLeft:[''],
			ElbowRight:[''],
			ElbowLeft:[''],
			AnkleRight:[''],
			AnkleLeft:[''],
			WristRight:[''],
			WristLeft:[''],
			FootRight:[''],
			FootLeft:[''],
			HandRight:[''],
			HandLeft:[''],
			ProbeType:[''],
			ImagingQuality:[''],
			Colonoscopy:[''],
			ColoComment:[''],
			Gastroscopy:[''],

		 })
	 }

   
	 resetAwl(){
		this.awlForm = this.fb.group({
			HMO:[''],
			AutoIndex:[''],
			refDocLastName:[''],
			BranchProviderName:[''],
			BranchProviderID:[''],
			refDocName:[''],
			Code:[''],
			PRN:[''],
			PRN2:[''],
			ExamCode:[''],
			Code2:[''],
			refDocName2:[''],
			BranchProviderID2:[''],
			BranchProviderName2:[''],
			refDocLastName2:[''],
			HMOExamCode:[''],
			HMOExamName:['']
		})
	}

	 buildList(data = this.gastroForm.get('DignosisTree').value){
			this.getATS();
			 this.diagnosis=[]
			 var diagnosisNum: string[] =[];
			 if(data){
				 diagnosisNum = data.split(',');
				 diagnosisNum.forEach((i) => {
					 if(i)
						if(+i < gastroDiagnosisList.length)
							this.diagnosis.push({index:i, value:gastroDiagnosisList[+i]?.value})
						else
							this.diagnosis.push({index: i, value: this.getTextsWithID(i)})
				 })
			 }
	 }

	 deleteDiagnosis(index:number){
		 if(this.es.isClosed)
			return;
		 var t ="";
		 if(this.diagnosis && index < this.diagnosis.length){
			this.diagnosis.splice(index, 1);
			t= this.diagnosis.length === 1 ? this.diagnosis[0].index : '';
			if(this.diagnosis.length >1){
				this.diagnosis.forEach((i) => {
					if(t === ''){
						t=i.index
					}else{
						t = t+','+i.index;
					}
				})
			}
			this.gastroForm.get('DignosisTree').patchValue(t);
			this.diagnosisChange$.next();

		}
	 }
	 saveDiagnosis(item = this.diag1, addnew = false){
			if(item && item.value){
					this.last = item
					var index;
					if(addnew)
						index = gastroDiagnosisList.length
					else
						index = gastroDiagnosisList.indexOf(item).toString()
				if(!this.gastroForm.get('DignosisTree').value){
				 this.gastroForm.get('DignosisTree').setValue(index.toString())
				}else if(this.gastroForm.get('DignosisTree').value == ''){
				 this.gastroForm.get('DignosisTree').setValue(index.toString())
				}else{

				 if(item && index != -1){
					 var t = this.gastroForm.get('DignosisTree').value;
					 if(! t.split(',').includes(index.toString())){
						 t += ','+index;
						 this.gastroForm.get('DignosisTree').patchValue(t);
					 }
				 }
				}
				this.diag1 ="";
				this.diagnosisChange$.next();
				// }
		 }
	}

	ngOnDestroy(): void {
			this.sub.unsubscribe()
	}


	getFindings(data){
		var temp = [];
		this.detailsFinding.forEach((i) => {
			i.value = data[i.db];
			i.comment = data[i.db+'Comment']
			if(i.value > -1){
				temp.push(i);
			}
		})
		return temp;
	}
	getATS(){
		let res = this.http.get('/api/autotext',{params:{field:'89'}});
		res.subscribe((data) => {
			this.summaryDiagnosisAT = data;
		})
	}

	getTextsWithID(id){
		if(this.last)
			return this.last.text;
		else
			return this.summaryDiagnosisAT[id - 130].Text;
	}

	getPatients(){
		return this.http.get('/api/gastro/GetTodayPatients');
	}
	getExams(PID:number){
		return this.http.get(`/api/gastro/GetExams/${PID}`);
	}

	signExam(signer){
		return this.http.post('/api/gastro/close/'+ this.es.examID,{'signer': signer});
	}
	getClosing(){
		return this.http.get('/api/gastro/closing/' + this.es.examID);
	}

	saveSign(form){
		 return this.http.post('/api/gastro/saveSign', {form: form, examid:this.es.examID})
	}
	getAllSigns(){
		return this.http.get('/api/gastro/getAllSigns/'+this.es.examID);
	}

	printCourseOfExam(print: boolean): any {
		return this.http
			.get(`/api/gastro/printCourseOfExam/${print}/${this.es.examID}`)
			.subscribe((data) => {});
	}

	printCourseOfExamStatus(): any {
		return this.http.get(
			`/api/gastro/printCourseOfExamStatus/${this.es.examID}`
		);
	}


	labResults(status:string, lab:string, uid){
		let params = {};
		if(uid && uid != 'null') params['uid'] = uid;
		if(lab) params['lab'] = lab;
		return this.http.get('/api/gastro/labresults/'+ status, { params: params });
	}

	getLabResultPdf(resultid){
		return this.http.get('/api/gastro/labresultpdf/' + resultid, { responseType: 'arraybuffer' });
	}

	getInventoryReportPdf(inventoryId){
		return this.http.get('/api/lab/inventoryreportpdf/' + inventoryId, { responseType: 'arraybuffer' });
	}

	getUnreadLabReports(){//for this doctor
		return this.http.get('/api/lab/unreadlabreports');
	}

}